<script>
  let error = "";
  let reg = '';
  export let number = null;
  export let isRequired = false;
  export let isMobile = false;
  export let isWork = false;
  export let isValid = false;
  export let placeholder = "";
  export let isDirty = false;
  export let label = "";
  export let ref = null;
  export let faIcon = null;
  export let readoutLabel = null;
  // let regex = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
  let phoneRegex = /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))$/;
  let mobileRegex = /^(((073)|(074)|(075)|(077)|(078)|(079))\d{2}\s?\d{3}\s?\d{3})$/;
  $: {reg = isMobile == 'true' ? mobileRegex : phoneRegex;}

  $: {
  error = '';
  const isEmpty = number === '' || number == null;
  const required = isRequired === 'true';
  const isMobileType = isMobile === 'true';
  const isWorkPhone = isWork === 'true';

  //isDirty = required && isEmpty;

  // Base validation: required field must not be empty
  if (required && isEmpty) {
    isValid = false;
    //isDirty = true;
    error = `Please enter your ${label}`;
  } 
  // If the field has a value, validate the format
  else if (!isEmpty) {
    if (!reg.test(number)) {
      isValid = false;
      isDirty = true;
      error = isMobileType
        ? "Invalid mobile number format. Please recheck number."
        : "Invalid number format. Please recheck number.";
    } else {
      // Extra validation: landline fields should not contain mobile numbers
      if (!isMobileType && number.startsWith('07')) {
        isValid = false;
        isDirty = true;
        error = "You have entered a mobile number as a landline. Please recheck number.";
      } else {
        isValid = true;
        isDirty = false;
      }
    }
  } 
  // Field is optional and empty
  else {
    isValid = true;
    isDirty = false;
  }
}


  function handleKeyUp(event){
    //if(number) isDirty = true;
    var charCode = event.which || event.keyCode;
    if(number)
    number=number.replace(/^\s+|\s+$/gm,'');

    if (isNaN(number) || (charCode > 64 && charCode < 91)) {
       //}else if(!(/^(?=.*\d)[\d ]+$/.test(text))){
       //isValid = false;
       event.preventDefault();
       if(number)
       number = number.replace(/[^\d]/gi, "");
       error = "This field only accepts numbers.";
     } 
  }


</script>
<style>
  .fa-icon {
    padding-top: 10px;
    padding-left: 10px;
  }
</style>

<input
  aria-label={readoutLabel ? readoutLabel : label}
  class="input {!isValid && isDirty ? 'is-danger' : ''}"
  type="tel"
  name="numberField"
  on:keyup={handleKeyUp}
  on:blur={ () => {

     if (number)
      number=number.replace(/^\s+|\s+$/gm,'');

      if (!isDirty)
        isDirty = (number != null && number != '');  
      } }
  bind:value={number}
  {placeholder}
  bind:this={ref} 
/>

{#if faIcon}
  <span class="icon is-small is-left fa-icon { faIcon }" />
{/if}
{#if !isValid && isDirty}
  <span>
    <p class="help has-text-danger">{error}</p>
  </span>
{/if}
